(()=>{
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const stacked=window.matchMedia('(min-width:750px)');
 const initialize=(root=document)=>{
  root.querySelectorAll('[data-ae-gallery]').forEach(gallery=>{
   if(gallery.dataset.aeReady)return;
   gallery.dataset.aeReady='true';
   const track=gallery.querySelector('[data-ae-track]');
   const slides=[...gallery.querySelectorAll('[data-ae-slide]')];
   const selectors=[...gallery.querySelectorAll('[data-ae-select]')];
   const previous=gallery.querySelector('[data-ae-previous]');
   const next=gallery.querySelector('[data-ae-next]');
   const count=gallery.querySelector('[data-ae-count]');
   const caption=gallery.querySelector('[data-ae-caption]');
   const dialog=gallery.querySelector('dialog');
   const dialogPrevious=gallery.querySelector('[data-ae-dialog-previous]');
   const dialogNext=gallery.querySelector('[data-ae-dialog-next]');
   let selected=0;
   let zoomIndex=0;
   let zoomRequest=0;
   let frame;
   const clamp=i=>Math.max(0,Math.min(slides.length-1,i));
   const update=()=>{
    if(!track.clientWidth)return;
    if(!stacked.matches)selected=clamp(Math.round(track.scrollLeft/track.clientWidth));
    track.tabIndex=stacked.matches?-1:0;
    track.setAttribute('aria-label',stacked.matches?track.dataset.aeStackLabel:track.dataset.aeSwipeLabel);
    selectors.forEach(button=>{
     const active=Number(button.dataset.aeSelect)===selected;
     if(button.hasAttribute('data-ae-thumb'))button.setAttribute('aria-pressed',String(active));
     button.classList.toggle('is-selected',active);
    });
    slides.forEach((slide,i)=>slide.querySelector('button').tabIndex=stacked.matches||i===selected?0:-1);
    count.textContent=String(selected+1).padStart(2,'0');
    if(caption)caption.textContent=slides[selected].dataset.caption;
    if(previous)previous.disabled=selected===0;
    if(next)next.disabled=selected===slides.length-1;
   };
   const choose=(index,instant=false)=>track.scrollTo({left:track.clientWidth*clamp(index),behavior:instant||reduced.matches?'instant':'smooth'});
   const showZoom=index=>{
    zoomIndex=clamp(index);
    const original=slides[zoomIndex].querySelector('img');
    const zoom=dialog.querySelector('img');
    zoom.removeAttribute('srcset');
    zoom.removeAttribute('sizes');
    zoom.loading='eager';
    const request=++zoomRequest;
    zoom.src=original.currentSrc||original.src;
    const large=new Image();
    large.onload=()=>{if(request===zoomRequest)zoom.src=large.src;};
    large.src=original.dataset.aeFull;
    zoom.alt=original.alt;
    gallery.querySelector('[data-ae-dialog-caption]').textContent=slides[zoomIndex].dataset.caption;
    const zoomCount=gallery.querySelector('[data-ae-dialog-count]');
    if(zoomCount)zoomCount.textContent=`${zoomIndex+1} / ${slides.length}`;
    if(dialogPrevious)dialogPrevious.disabled=zoomIndex===0;
    if(dialogNext)dialogNext.disabled=zoomIndex===slides.length-1;
   };
   const openZoom=index=>{
    showZoom(index);
    document.documentElement.classList.add('ae-gallery-open');
    dialog.showModal();
   };
   selectors.forEach(button=>button.addEventListener('click',()=>choose(Number(button.dataset.aeSelect))));
   previous?.addEventListener('click',()=>choose(selected-1));
   next?.addEventListener('click',()=>choose(selected+1));
   track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
   track.addEventListener('keydown',event=>{
    if(stacked.matches)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();choose(selected+(event.key==='ArrowRight'?1:-1));}
    if(event.key==='Home'||event.key==='End'){event.preventDefault();choose(event.key==='Home'?0:slides.length-1);}
   });
   slides.forEach((slide,i)=>slide.querySelector('button').addEventListener('click',()=>openZoom(i)));
   gallery.querySelector('[data-ae-enlarge]').addEventListener('click',()=>openZoom(selected));
   gallery.querySelector('[data-ae-close]').addEventListener('click',()=>dialog.close());
   dialogPrevious?.addEventListener('click',()=>showZoom(zoomIndex-1));
   dialogNext?.addEventListener('click',()=>showZoom(zoomIndex+1));
   dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showZoom(zoomIndex+(event.key==='ArrowRight'?1:-1));}});
   dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
   dialog.addEventListener('close',()=>{document.documentElement.classList.remove('ae-gallery-open');if(!stacked.matches)choose(zoomIndex,true);});
   const info=gallery.closest('.at-product-grid')?.querySelector('.at-product-info');
   const updateSticky=()=>{
    if(info)info.style.setProperty('--ae-details-top',Math.min(76,window.innerHeight-info.offsetHeight-24)+'px');
   };
   const updateLayout=()=>{
    if(!stacked.matches)choose(selected,true);
    update();updateSticky();
   };
   const onResize=new ResizeObserver(updateLayout);
   onResize.observe(track);
   if(info)onResize.observe(info);
   window.addEventListener('resize',updateSticky,{passive:true});
   stacked.addEventListener('change',updateLayout);
   const visibility=new IntersectionObserver(entries=>document.documentElement.classList.toggle('ae-viewing-gallery',entries.some(e=>e.isIntersecting)),{threshold:0});
   visibility.observe(gallery);
   const unload=event=>{
    if(!event.target.contains(gallery))return;
    onResize.disconnect();visibility.disconnect();cancelAnimationFrame(frame);
    window.removeEventListener('resize',updateSticky);
    stacked.removeEventListener('change',updateLayout);
    info?.style.removeProperty('--ae-details-top');
    document.documentElement.classList.remove('ae-viewing-gallery','ae-gallery-open');
    document.removeEventListener('shopify:section:unload',unload);
   };
   document.addEventListener('shopify:section:unload',unload);
   updateLayout();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
